import { getApi } from '../../libs/api-client';

export function requestEmailChange(email: string): Promise<any> {
  return getApi().post<any>('/api/auth/update_email', { email });
}

export function validateEmailChange(code: string): Promise<any> {
  return getApi().post<any>('/api/auth/validate_email', { code });
}
